'use strict';

module.exports = /* @ngInject */ function ($scope, linkOrderService, notificationService, translationService) {
	let orderId;

	let history = null;

	/**
	 * There is a bug in the select2 library that the variable passed to ng-model has to be an object property.
	 * For that reason the selected orders and the search results are stored inside this object.
	 * @type {{search: [], comment: string, selected: []}}
	 */
	$scope.orders = {
		selected: [],
		data: [],
		toDelete: []
	};

	$scope.comment = '';

	$scope.init = init;
	$scope.search = search;
	$scope.save = save;
	$scope.abort = abort;

	function init(id) {
		orderId = id;
		linkOrderService.getOrderHistory.query().$promise.then(result => {
			history = result;
			$scope.orders.data = result;
		})
	}

	/**
	 * search for orders by orderId
	 * @param searchTerm
	 */
	function search(searchTerm) {
		if (searchTerm) {
			linkOrderService.searchOrders.query({orderId: searchTerm}).$promise.then(searchResult => {
				$scope.orders.data = searchResult;
			})
		} else {
			$scope.orders.data = history;
		}
		$scope.$apply();
	}

	/**
	 * saves the selected orders as relations to this order
	 * @returns {Promise<void>}
	 */
	async function save() {
		if ($scope.orders.selected.length && $scope.comment && !$scope.loading) {
			$scope.loading = true;
			for (let order of $scope.orders.selected) {
				const body = {
					order: {
						id: orderId
					},
					relatesTo: {
						id: order.id
					},
					comment: $scope.comment
				};
				try {
					await linkOrderService.saveOrderLink.create(body).$promise;
				} catch (e) {
					console.error(e);
					const errorMessage =
						translationService.translate(_('Beim Verknüpfen der Bestellungen ist leider ein Fehler aufgetreten...'));
					notificationService.showErrorNotification(errorMessage);
					window.closePopup();
					return;
				}
			}
			const successMessage = translationService.translate(_('Bestellungen erfolgreich verknüpft.'));
			notificationService.showSuccessNotification(successMessage);
			window.devReload();
			window.closePopup();
		}
	}

	/**
	 * closes the popup
	 */
	function abort() {
		window.closePopup();
	}

}
